/**
 * Copyright © Veeam Software Group GmbH.
 */

import { VacInternalItemType as VacInternalItemTypeModel } from '@veeam-vspc/models/web-controllers';

export const VacInternalItemType = VacInternalItemTypeModel;
export type VacInternalItemType = VacInternalItemTypeModel;
